import type { Backlink, DocumentBacklinks, DocumentEntity } from '@/api';

type BacklinkFields = Pick<Partial<DocumentEntity | DocumentBacklinks>, 'backlinks'>;

export const getDocumentBacklinks = (document: BacklinkFields | null | undefined): Backlink[] =>
  document?.backlinks ?? [];

export const getDocumentBacklinksCount = (document: BacklinkFields | null | undefined): number =>
  getDocumentBacklinks(document).length;
